import React from 'react';
import PermissionRoute from './PermissionRoute';
import { authApi, getAuthToken } from '../../lib/api/auth';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => (
  <PermissionRoute
    module="project-analysis"
    getAuthToken={getAuthToken}
    fetchUser={authApi.fetchUser}
    noAccessPath="/panel/no-access"
  >
    {children}
  </PermissionRoute>
);

export default ProtectedRoute;
